import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'
import users from './modules/users'
import roles from './modules/roles'
import permissions from './modules/permissions'
import eventTypes from './modules/event-types'
import reservations from './modules/reservations'
import buildings from './modules/buildings'
import floors from './modules/floors'
import rooms from './modules/rooms'
import attributes from './modules/attributes'
import customers from './modules/customers'
import samadh from './modules/samadh'
import electrical from './modules/electrical'
import pos from './modules/pos'
import dispensary from './modules/dispensary'
import vims from './modules/vims'
import gate from './modules/gate'



Vue.use(Vuex)

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  modules: {
    users,
    roles,
    permissions,
    eventTypes,
    reservations,
    buildings,
    floors,
    rooms,
    attributes,
    customers,
    samadh,
    electrical,
    pos,
    dispensary,
    vims,
    gate
  },
  strict: debug,
  plugins: debug ? [createLogger()] : []
})
